import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import undrawProfile from "../img/undraw_profile.svg";
import { AppContext } from "../contexts/AppContext";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import info from "../img/info.png";

const options = {
  rewind: true,
  perPage: 2,
  type: "loop",
  gap: "1rem",
  autoplay: true,
  pauseOnHover: false,
  resetProgress: false,
  arrows: false,
};

const ProfileViewOnly = ({ userData, testData, isViewPublic = false }) => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <>
      {!isViewPublic || (isViewPublic && userData?.about !== null) ? (
        <div className="mx-4 mt-4">
          <div
            className="card-body "
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">About</p>
              </div>
              <div className="col-6 col-md-6" />

              <div className="col-12 col-md-12">
                <p className="pro-p">{userData?.about || ""}</p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!isViewPublic || (isViewPublic && userData?.experiences !== null) ? (
        <div className=" mx-4 mt-4">
          <div
            className="card-body "
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Headline</p>
              </div>
              <div className="col-6 col-md-6" />
              <div className="col-12 col-md-12">
                <p className="">{userData?.experiences || ""}</p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!isViewPublic || (isViewPublic && userData?.userEducations !== null) ? (
        <div className=" mx-4 mt-4">
          <div
            className="card-body py-2"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Education</p>
              </div>
              <div className="col-6 col-md-6" />
              <div className="col-12 col-md-12">
                {Array.isArray(userData?.userEducations) &&
                  userData?.userEducations?.length > 0 &&
                  userData?.userEducations.map(
                    (
                      {
                        institution_name,
                        institution_department,
                        start_year,
                        end_year,
                      },
                      index
                    ) => (
                      <p className="pro-p" key={index}>
                        <span className="bold">{institution_name || ""}</span>
                        <br />
                        {institution_department || ""}
                        <br />
                        {start_year
                          ? moment(start_year).format("YYYY")
                          : ""} -{" "}
                        {end_year ? moment(end_year).format("YYYY") : ""}
                        <hr></hr>
                      </p>
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!isViewPublic || (isViewPublic && userData?.userExperiances !== null) ? (
        <div className=" mx-4 mt-4">
          <div
            className="card-body py-2"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Experience</p>
              </div>
              <div className="col-6 col-md-6" />
              <div className="col-12 col-md-12">
                {Array.isArray(userData?.userExperiances) &&
                  userData?.userExperiances?.length > 0 &&
                  userData?.userExperiances.map(
                    ({ company_name, position, experiance }, index) => (
                      <p className="pro-p" key={index}>
                        <span className="bold">{company_name || ""}</span>
                        <br />
                        {position || ""}
                        <br />
                        {experiance || ""}
                        <hr></hr>
                      </p>
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!isViewPublic || (isViewPublic && userData?.skills !== null) ? (
        <div className=" mx-4 mt-4">
          <div
            className="card-body py-2"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-12 col-md-12">
                <p className="pro-title">Skills</p>
              </div>
              <div className="col-12 col-md-12">
                <div className="">
                  {Array.isArray(userData?.skills) &&
                    userData?.skills?.length > 0 &&
                    userData?.skills.map(({ value }, index) => (
                      <p className="pro-p mr-3 skills" key={index}>
                        {value || ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {!isViewPublic && (
        <div className=" mx-4 mt-4">
          <div
            className="card-body py-2"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-12 col-md-12">
                <p className="pro-title">Skill Categories</p>
              </div>
              <div className="col-12 col-md-12">
                <div className="">
                  {Array.isArray(userData?.userSkillsCategories) &&
                    userData?.userSkillsCategories?.length > 0 &&
                    userData?.userSkillsCategories.map(({ name }, index) => (
                      <p className="pro-p mr-3 skills" key={index}>
                        {name || ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {userData?.offerService && (
        <div className="mx-4 mt-4">
          <div
            className="card-body py-2"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-12 col-md-12">
                <p className="pro-title">
                  SME{" "}
                  <span className="explain">
                    (Subject matter expertise refers to the specific area or
                    topic in which an individual can mentor)
                  </span>{" "}
                  <div className="tool-tip">
                    <div className="info-icon">
                      <img src={info} alt="info" />
                    </div>
                    <div className="tooltiptext">
                      Subject matter expertise indicates the specific field or
                      topic where users can provide their specialized knowledge
                      during sessions. This information is used to filter and
                      match users seeking experts with expertise in a particular
                      area. By highlighting your expertise, you increase the
                      chances of being found by those seeking guidance or advice
                      in your field.
                    </div>
                  </div>
                </p>
              </div>
              <div className="col-12 col-md-12">
                <div className="">
                  {Array.isArray(userData?.experties) &&
                    userData?.experties?.length > 0 &&
                    userData?.experties.map(({ value }, index) => (
                      <p className="pro-p mr-3 skills" key={index}>
                        {value || ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {!isViewPublic || (isViewPublic && userData?.interest !== null) ? (
        <div className=" mx-4 mt-4">
          <div
            className="card-body py-2"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
              cursor: "default",
            }}
          >
            <div className="row">
              <div className="col-12 col-md-12">
                <p className="pro-title">Interest</p>
              </div>
              <div className="col-12 col-md-12">
                <div className="">
                  {Array.isArray(userData?.interest) &&
                    userData?.interest?.length > 0 &&
                    userData?.interest.map(({ value }, index) => (
                      <p className="pro-p mr-3 skills" key={index}>
                        {value || ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {!isViewPublic && (
        <div className="row mt-3 testimonials-wrapper">
          <div className="col-12 col-md-12">
            <div className="row">
              <div className="col-md-6">
                <p className="test-txt ml-2">Testimonials</p>
              </div>
              {testData.length > 2 && (
                <div className="col-6 ml-auto">
                  <p
                    className="show-more ml-2 text-right cursor-pointer"
                    onClick={() =>
                      navigate(`../user/${userData?.userId}/testimonials`)
                    }
                  >
                    View more
                  </p>
                </div>
              )}
            </div>

            <div className="row">
              {testData.length > 0 ? (
                testData.slice(0, 2).map((item) => {
                  return (
                    <div className="col-12 col-md-12">
                      <div className="profile-card testimonial-card d-block">
                        <div className="d-flex p-2">
                          <div className="sme-profile">
                            <img
                              className={`img-profile rounded-circle ${
                                item?.createdByOfferService
                                  ? "sme-mini-service"
                                  : null
                              }`}
                              src={item?.mentee_pic_url || undrawProfile}
                              alt="Profile"
                              onClick={() =>
                                navigate(`../${item?.createdByUsername}`)
                              }
                            />
                            {item?.createdByOfferService && (
                              <div className="sme-mini-icon">SME</div>
                            )}
                          </div>
                          <p
                            className="ml-1 mt-2 test-name"
                            onClick={() =>
                              navigate(`../${item?.createdByUsername}`)
                            }
                          >
                            {item?.mentee_name || "User"}
                          </p>
                        </div>
                        <p className="p-2 test-p mb-0">
                          {item?.description || ""}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="d-block no-testmonial">
                  No Testimonials available
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const ProfileEdit = ({
  userData,
  testData,
  isPublic = false,
  isVisible = {},
  onVisibilityChangeHandler = null,
}) => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <>
      <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
        <div className="card-body py-2">
          <div
            className="card-body"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">About</p>
              </div>
              <div className="col-6 col-md-6">
                {isPublic ? (
                  <label class="switch ml-3 float-right">
                    <input
                      type="checkbox"
                      checked={isVisible["about"]}
                      onChange={() => onVisibilityChangeHandler("about")}
                    />
                    <span class="slider round"></span>
                  </label>
                ) : (
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType("addAbout", "About")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12">
                <p className="pro-p">{userData?.about || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
        <div className="card-body py-2">
          <div
            className="card-body"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Headline</p>
              </div>
              <div className="col-6 col-md-6">
                {isPublic ? (
                  <label class="switch ml-3 float-right">
                    <input
                      type="checkbox"
                      checked={isVisible["headline"]}
                      onChange={() => onVisibilityChangeHandler("headline")}
                    />
                    <span class="slider round"></span>
                  </label>
                ) : (
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType("addHeadline", "Headline")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12">
                <p className="pro-p">{userData?.experiences || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
        <div className="card-body py-2">
          <div
            className="card-body"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Education</p>
              </div>
              <div className="col-6 col-md-6">
                {isPublic ? (
                  <label class="switch ml-3 float-right">
                    <input
                      type="checkbox"
                      checked={isVisible["education"]}
                      onChange={() => onVisibilityChangeHandler("education")}
                    />
                    <span class="slider round"></span>
                  </label>
                ) : (
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType("addEducation", "Education")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12">
                {Array.isArray(userData?.userEducations) &&
                  userData?.userEducations?.length > 0 &&
                  userData?.userEducations.map(
                    (
                      {
                        institution_name,
                        institution_department,
                        start_year,
                        end_year,
                      },
                      index
                    ) => (
                      <p className="pro-p" key={index}>
                        <span className="bold">{institution_name || ""}</span>
                        <br />
                        {institution_department || ""}
                        <br />
                        {start_year
                          ? moment(start_year).format("YYYY")
                          : ""} -{" "}
                        {end_year ? moment(end_year).format("YYYY") : ""}
                        <hr></hr>
                      </p>
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
        <div className="card-body py-2">
          <div
            className="card-body"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Experience</p>
              </div>
              <div className="col-6 col-md-6">
                {isPublic ? (
                  <label class="switch ml-3 float-right">
                    <input
                      type="checkbox"
                      checked={isVisible["experience"]}
                      onChange={() => onVisibilityChangeHandler("experience")}
                    />
                    <span class="slider round"></span>
                  </label>
                ) : (
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType("addExperience", "Experience")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12">
                {Array.isArray(userData?.userExperiances) &&
                  userData?.userExperiances?.length > 0 &&
                  userData?.userExperiances.map(
                    ({ company_name, position, experiance }, index) => (
                      <p className="pro-p" key={index}>
                        <span className="bold">{company_name || ""}</span>
                        <br />
                        {position || ""}
                        <br />
                        {experiance || ""}
                        <hr></hr>
                      </p>
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
        <div className="card-body py-2">
          <div
            className="card-body"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Skills</p>
              </div>
              <div className="col-6 col-md-6">
                {isPublic ? (
                  <label class="switch ml-3 float-right">
                    <input
                      type="checkbox"
                      checked={isVisible["skills"]}
                      onChange={() => onVisibilityChangeHandler("skills")}
                    />
                    <span class="slider round"></span>
                  </label>
                ) : (
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType("addSkills", "Skills")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12">
                <div className="">
                  {Array.isArray(userData?.skills) &&
                    userData?.skills?.length > 0 &&
                    userData?.skills.map(({ value }, index) => (
                      <p className="pro-p mr-3 skills" key={index}>
                        {value || ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {userData?.offerService && !isPublic && (
        <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
          <div className="card-body py-2">
            <div
              className="card-body"
              style={{
                backgroundColor: "#F7F8FD",
                borderRadius: "1rem",
                border: "1px solid #999",
              }}
            >
              <div className="row">
                <div className="col-10 col-sm-10 col-md-10 col-lg-10">
                  <p className="pro-title">
                    SME{" "}
                    <span className="explain">
                      (Subject matter expertise refers to the specific area or
                      topic in which an individual can mentor)
                    </span>
                    <div className="tool-tip">
                      <div className="info-icon">
                        <img src={info} alt="info" />
                      </div>
                      <div className="tooltiptext">
                        Subject matter expertise indicates the specific field or
                        topic where users can provide their specialized
                        knowledge during sessions. This information is used to
                        filter and match users seeking experts with expertise in
                        a particular area. By highlighting your expertise, you
                        increase the chances of being found by those seeking
                        guidance or advice in your field.
                      </div>
                    </div>
                  </p>
                </div>
                <div className="col-2 col-sm-2 col-md-2 col-lg-2">
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType(
                        "addExpertise",
                        "Subject matter expertise (SME)"
                      )
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                </div>
                <div className="col-12 col-md-12">
                  <div className="">
                    {Array.isArray(userData?.experties) &&
                      userData?.experties?.length > 0 &&
                      userData?.experties.map(({ value }, index) => (
                        <p className="pro-p mr-3 skills" key={index}>
                          {value || ""}
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={isPublic ? "mt-2" : "mt-2 mx-2"}>
        <div className="card-body py-2">
          <div
            className="card-body"
            style={{
              backgroundColor: "#F7F8FD",
              borderRadius: "1rem",
              border: "1px solid #999",
            }}
          >
            <div className="row">
              <div className="col-6 col-md-6">
                <p className="pro-title">Interest</p>
              </div>
              <div className="col-6 col-md-6">
                {isPublic ? (
                  <label class="switch ml-3 float-right">
                    <input
                      type="checkbox"
                      checked={isVisible["interest"]}
                      onChange={() => onVisibilityChangeHandler("interest")}
                    />
                    <span class="slider round"></span>
                  </label>
                ) : (
                  <span
                    className="float-right cursor-pointer pen-icon"
                    data-toggle="modal"
                    data-target="#about"
                    onClick={() =>
                      appContext.updateModalType("addInterest", "Interest")
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                        fill="#575757"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12">
                <div className="">
                  {Array.isArray(userData?.interest) &&
                    userData?.interest?.length > 0 &&
                    userData?.interest.map(({ value }, index) => (
                      <p className="pro-p mr-3 skills" key={index}>
                        {value || ""}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!isPublic && (
        <div className="row mt-3 testimonials-wrapper">
          <div className="col-12 col-md-12">
            <div className="row">
              <div className="col-md-6">
                <p className="test-txt ml-2">Testimonials</p>
              </div>
              {testData.length > 2 && (
                <div className="col-6 ml-auto">
                  <p
                    className="show-more ml-2 text-right cursor-pointer"
                    onClick={() => navigate("../myspace/testimonials")}
                  >
                    View more
                  </p>
                </div>
              )}
            </div>
            {/* {testData.length > 0 ? (
            <Splide options={options}>
              {testData.map((item) =>
                item.length > 1 ? (
                  <SplideSlide>
                    <div className="profile-card">
                      <p className="p-2 test-p mb-0">
                        {item?.description || ""}
                      </p>
                      <div className="d-flex p-2">
                        <img
                          className="img-profile rounded-circle"
                          src={item?.mentor_pic_url || undrawProfile}
                          alt="Profile"
                        />
                        <p className="ml-1 mt-2 test-name">
                          {item?.mentor_name || "User"}
                        </p>
                      </div>
                    </div>
                  </SplideSlide>
                ) : (
                  <div className="col-12 col-md-6">
                    <div className="profile-card">
                      <div className="d-flex p-2">
                        <img
                          className="img-profile rounded-circle"
                          src={item?.mentor_pic_url || undrawProfile}
                          alt="Profile"
                        />
                        <p className="ml-1 mt-2 test-name">
                          {item?.mentor_name || "User"}
                        </p>
                      </div>
                      <p className="p-2 test-p mb-0">
                        {item?.description || ""}
                      </p>
                    </div>
                  </div>
                )
              )}
            </Splide>
          ) : (
            <p className="d-block">No Testimonials available</p>
          )} */}
            <div className="row">
              {testData.length > 0 ? (
                testData.slice(0, 2).map((item) => {
                  return (
                    <div className="col-12 col-md-12">
                      <div className="profile-card testimonial-card">
                        <div className="d-flex p-2">
                          <div className="sme-profile">
                            <img
                              className={`img-profile rounded-circle ${
                                item?.createdForOfferService
                                  ? "sme-mini-service"
                                  : null
                              }`}
                              src={item?.mentor_pic_url || undrawProfile}
                              alt="Profile"
                              onClick={() =>
                                navigate(`../${item?.createdForUsername}`)
                              }
                            />
                            {item?.createdForOfferService && (
                              <div className="sme-mini-icon">SME</div>
                            )}
                          </div>
                          <p
                            className="ml-1 mt-2 test-name"
                            onClick={() =>
                              navigate(`../${item?.createdForUsername}`)
                            }
                          >
                            {item?.mentor_name || "User"}
                          </p>
                        </div>
                        <p className="p-2 test-p mb-0">
                          {item?.description || ""}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="d-block no-testimonial">
                  No Testimonials available
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* <div className="row mt-3 ml-4">
        <p className="test-txt">Testimonials</p>
      </div>
      <div className="row">
        <div className="col-12 col-md-12 ml-4">
          <p>There are no Testimonials right now</p>
        </div>
      </div> */}
    </>
  );
};

const ProfileView = ({
  type,
  viewUserData,
  testData = [],
  isPublic = false,
  isVisible = null,
  onVisibilityChangeHandler = null,
  isViewPublic = false,
}) => {
  const { userData } = useSelector((state) => state.user);
  return (
    <>
      {type === "edit" ? (
        <ProfileEdit
          userData={userData}
          testData={testData}
          isPublic={isPublic}
          isVisible={isVisible}
          onVisibilityChangeHandler={onVisibilityChangeHandler}
        />
      ) : (
        <ProfileViewOnly
          userData={viewUserData}
          testData={testData}
          isViewPublic={isViewPublic}
        />
      )}
    </>
  );
};

export default ProfileView;
